const POST_AD_ENABLED_COUNTRY_CODES = new Set(['CH'])

export const isPostAdEnabled = (countryCode: string) =>
  POST_AD_ENABLED_COUNTRY_CODES.has(countryCode)